export const GET_POSITIONS__REQUEST = 'POSITION_TYPE__GET_POSITIONS__REQUEST';
export const GET_POSITIONS__SUCCESS = 'POSITION_TYPE__GET_POSITIONS__SUCCESS';
export const GET_POSITIONS__FAILURE = 'POSITION_TYPE__GET_POSITIONS__FAILURE';
